import ProfessionsList from './ProfessionsList.vue';

export default ProfessionsList;



// WEBPACK FOOTER //
// ./src/pages/professions/list/index.ts